export default "__VITE_ASSET__4b09b31f__"